/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TrackingModel { 
    id?: number;
    orderId?: number;
    referrer?: string;
    referrerComment?: string;
    utmMedium?: string;
    utmSource?: string;
    utmCampaign?: string;
    utmId?: string;
    utmTerm?: string;
    utmContent?: string;
    gclid?: string;
}

